angular.module('autoremind.reports.survey', [])
    .directive('reportsCommunicationsSurvey', ['$rootScope', '$sce', '$timeout', 'dialogs', 'surveyService', 'jobService', '$routeParams', '$location', 'messagesService',
    function ($rootScope, $sce, $timeout, dialogs, surveyService, jobService, $routeParams, $location, messagesService) {
        return {
            restrict: 'EA',
            templateUrl: 'app/reports/communication/survey/survey.html',
            scope: false,
            link: function (scope, elem, attr) {
                console.log('survey report');
                scope.messages = [];
                scope.iframeUrl = null;
                scope.jobId = null;
                scope.loaderIndicator = false;
                scope.job = jobService.job;
                scope.errorMessage = false;
                scope.openSurvey = function (jobId) {
                    scope.iframeUrl = null;
                    scope.errorMessage = false;
                    scope.loaderIndicator = true;
                    jobService.job.getJob(jobId)
                        .then(function () {
                        $timeout(function () {
                            scope.loaderIndicator = false;
                            if (scope.job.data.jobCategory !== 'reviews') {
                                if (typeof scope.job.data.jobContent.template.surveyResultUrl === 'undefined' || scope.job.data.jobContent.template.surveyResultUrl === '') {
                                    scope.errorMessage = true;
                                    return;
                                }
                                scope.iframeUrl = $sce.trustAsResourceUrl(scope.job.data.jobContent.template.surveyResultUrl);
                            }
                            else {
                                scope.iframeUrl = $sce.trustAsResourceUrl(scope.job.data.jobDescription);
                            }
                        }, 0);
                    }, function () {
                        scope.loaderIndicator = false;
                        scope.errorMessage = true;
                    });
                };
                scope.loadMessages = function (id) {
                    scope.loaderIndicator = true;
                    messagesService.offset = messagesService.defOffset;
                    messagesService.getMessages(id, null, 'full')
                        .then(function (messages) {
                        scope.messages = messages.messages;
                        scope.loaderIndicator = false;
                    }, function () {
                        scope.loaderIndicator = false;
                    });
                };
                scope.openJobBrowser = function () {
                    var dialog = dialogs.create('app/communication/communications.select.job.html', 'autoremind.communications.BrowseJobController', { communicationsCategory: { communicationsCategoryId: 'survey', communicationsCategoryName: 'Survey' }, jobs: jobService.jobs }, //TODO: let dialog just use service? or give category and list only?
                    { key: false, back: 'static' });
                    dialog.result
                        .then(function (jobId) {
                        if (jobId) {
                            $location.search({ "jobid": jobId });
                            //scope.openSurvey(reportId);
                        }
                    }, function () {
                    });
                };
                console.log($routeParams);
                if (angular.isDefined($routeParams.jobid)) {
                    scope.jobId = $routeParams.jobid;
                    scope.openSurvey($routeParams.jobid);
                }
                else {
                    scope.openJobBrowser();
                }
                $rootScope.$on('event:auth-loginConfirmed', function () {
                    $location.search('jobid', null);
                });
            }
        };
    }])
    .directive('iframeSetDimensionsOnload', ['$window', function ($window) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.on('load', function () {
                    element.css('height', $window.innerHeight - 120);
                    element.css('width', '100%');
                    element.show();
                });
                angular.element($window).bind('resize', function () {
                    element.css('height', $window.innerHeight - 120);
                    scope.$digest();
                });
            }
        };
    }]);
//# sourceMappingURL=survey.directive.js.map